import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import emptyConfig from "../../config/empty";
import { Timestamp } from "firebase/firestore";
import { Config } from "../../config/companies/config";

export type Company = {
  name: string;
  id: string;
  type: string;
};

export type FirestoreUser = User & {
  createdAt: Timestamp;
  updatedAt: Timestamp;
};
export type User = {
  uid: string;
  email: string;
  role: string;
  company: null | Company;
  firstName: string;
  lastName: string;
  fullName: string;
  avatarUrl?: string | null;
  birthDate?: string | null;
};

export type AuthState = {
  user: User;
  theme: string;
  config: Config;
  timestamp: number;
  language: "kk" | "ru";
};

export const authInitialState: AuthState = {
  user: {
    uid: "",
    email: "",
    role: "",
    company: null,
    firstName: "",
    lastName: "",
    fullName: "",
    avatarUrl: "",
    birthDate: null,
  },
  theme: "light",
  config: emptyConfig,
  timestamp: Date.now(),
  language: "kk",
};

const authSlice = createSlice({
  name: "auth",
  initialState: authInitialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    toggleThemeAction: (state) => {
      state.theme = state.theme === "light" ? "dark" : "light";
    },
    logOutAction: (state) => {
      state.user = authInitialState.user;
      state.config = authInitialState.config;
      state.timestamp = authInitialState.timestamp;
    },
    setCompany: (state, action: PayloadAction<Company>) => {
      state.user.company = action.payload;
    },
    setConfig: (state, action: PayloadAction<Config>) => {
      state.config = action.payload;
    },
    updateTimestampAction: (state) => {
      state.timestamp = Date.now();
    },
    setLanguageAction: (state, action: PayloadAction<"kk" | "ru">) => {
      state.language = action.payload;
    },
  },
});

export const {
  setUser,
  logOutAction,
  toggleThemeAction,
  setCompany,
  setConfig,
  setLanguageAction,
  updateTimestampAction,
} = authSlice.actions;
export default authSlice.reducer;
